<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="containerStyle2" md10 lg10 xs12 sm11>
        <v-layout>
          <v-flex md12 lg12 xs12 sm12 xl12>
            <v-tabs dark color="#1c345d" fixed-tabs>
              <v-tab :to="{name: 'estadoE5'}">Estado</v-tab>
              <v-tab :to="{name: 'anexosOEtapa5'}">Informe CEPP</v-tab>
              <v-tab :to="{name: 'anexosCEtapa5'}">Documentos de Autoevaluación</v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
        <v-layout>
          <router-view />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../../assets/BANNER_7.png";

export default {
  data() {
    return {
      img1: img1,
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      ver: false,
      edit: true,
      content: "asjlkdhasjkd",
      currentPage: 0,
      pageCount: 0,
      src: "",
      numPages: undefined,
      archivo: "",
      thispdf: "",
      personas: [
        {
          fecha: "24 de septiembre 2019, a las 12:30",
          resumen:
            "'Hoy en día Chile no se ha preparado para estos wicked problem, por lo que hay que trabajar en una estrategia más competitiva para el país…'",
          nombre: "Luis Migryk"
        },
        {
          fecha: "24 de septiembre 2019",
          resumen:
            "'Hoy en día Chile no se ha preparado para estos wicked problem, por lo que hay que trabajar en una estrategia más competitiva para el país…'",
          nombre: "Francisco Acuña"
        },
        {
          fecha: "24 de septiembre 2019, a las 12:30",
          resumen:
            "'Hoy en día Chile no se ha preparado para estos wicked problem, por lo que hay que trabajar en una estrategia más competitiva para el país…'",
          nombre: "Luis Migryk"
        },
        {
          fecha: "24 de septiembre 2019",
          resumen:
            "'Hoy en día Chile no se ha preparado para estos wicked problem, por lo que hay que trabajar en una estrategia más competitiva para el país…'",
          nombre: "Francisco Acuña"
        }
      ],
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      vacio: false
    };
  },

  created() {},

  methods: {
    downloadFile(archivo) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(archivo.path);
      var nameFile = archivo.titulo;
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      //console.log(url);
      this.thispdf = url;
      this.src = pdf.createLoadingTask(url);
      this.src.then(pdf => {
        this.numPages = pdf.numPages;
      });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>

<style scoped>
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}

.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}
.v-card__title {
  background: #eb7704;
  font-size: 12px;
  padding: 5px;
}

.v-card__text {
  background-color: #474a4e;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
}
.dialog-card {
  height: 100% !important;
  width: 100% !important;
}

.left-card {
  width: 100% !important;
  background-color: #ffffff !important;
  border-radius: 0% !important;
  text-align: justify !important;
  padding: 2% !important;
  margin: 0% !important;
}

.scroll-pdf {
  width: 50% !important;
  height: 90% !important;
  padding-left: 1% !important;
  padding-right: 1% !important;
  position: absolute;
  overflow-y: auto;
  overflow-x: none;
}

.container--style {
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.carousel {
  height: 650px !important;
  width: 650px !important;
  margin: 1% auto 1% auto !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.image {
  cursor: pointer;
}

.pdf {
  width: 100% !important;
  height: auto !important;
  display: inline-block !important;
  margin-bottom: 10px !important;
  border-style: groove;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #eb7704;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #eb7704;
}
</style>



// WEBPACK FOOTER //
// src/components/dca/documentosPost/DocumentosEtapa5.vue